import * as React from 'react'

const useToggle = (initialState: boolean): [boolean, () => void] => {
  const [state, setState] = React.useState(initialState)
  const toggleState = () => {
    setState(!state)
  }
  return [state, toggleState]
}

export default useToggle
